import { render, staticRenderFns } from "./ItemDetailCDIModal.vue?vue&type=template&id=7c43f057&"
import script from "./ItemDetailCDIModal.vue?vue&type=script&lang=js&"
export * from "./ItemDetailCDIModal.vue?vue&type=script&lang=js&"
import style0 from "./ItemDetailCDIModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports